import {h} from 'preact';

import * as T from "../desktop-templates/prematch-right-col.jsx";
import * as M from "../desktop-templates/prematch-menu.jsx";



export default function FastBet() {
	return null;
	return <div>
		<T.ColumnTitleRow>
		  <T.ColumnTitleLabel>Fast Bet</T.ColumnTitleLabel>
		</T.ColumnTitleRow>
		<T.ColumnContent>
		  <T.ContentRow>
			<T.InputContainer></T.InputContainer>
		  </T.ContentRow>
		  <T.ContentRow>
			<T.InputContainer></T.InputContainer>
		  </T.ContentRow>
		  <T.ContentRowFlex>
			<T.InputContainer></T.InputContainer>
			<T.SubmitButton />
		  </T.ContentRowFlex>
		</T.ColumnContent>
		<M.BlankSeparator />
	</div>
}
